/*
 * @Author: Scarlett Xiao
 * @Date: 2021-12-22 09:52:28
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-09-07 16:15:18
 */

/////////////////// 总裁 ////////////////////// 
export const constantRoutes = [
    /////////////////// 育苗 ////////////////////// 
    {
        path: '/ym',
        name: 'ym',
        component: () =>
            import("../../views/pc/president/ym.vue"),
        meta: {
            title: '育苗'
        },
    },
    {
        path: '/ym/annals-target',
        name: 'ym-annals-target',
        component: () =>
            import("../../views/pc/president/ym-annals-target/ym-annals-target.vue"),

        meta: {
            title: '年度经营目标完成情况'
        },
    },
    {
        path: '/ym/put',
        name: 'ym-put',
        component: () =>
            import("../../views/pc/president/ym-put/ym-put.vue"),
        meta: {
            title: '投放概览'
        },
    },
    {
        path: '/ym/overage',
        name: 'ym-overage',
        component: () =>
            import("../../views/pc/president/ym-overage/ym-overage.vue"),
        meta: {
            title: '存塘概览'
        },
    },
    {
        path: '/ym/cost',
        name: 'ym-cost',
        component: () =>
            import("../../views/pc/president/ym-cost/ym-cost.vue"),
        meta: {
            title: '成本概览'
        },
    },
    {
        path: '/ym/harvest',
        name: 'ym-harvest',
        component: () =>
            import("../../views/pc/president/ym-harvest/ym-harvest.vue"),
        meta: {
            title: '收获概览'
        },
    },
    {
        path: '/ym/sales',
        name: 'ym-sales',
        component: () =>
            import("../../views/pc/president/ym-sales/ym-sales.vue"),
        meta: {
            title: '销售概览'
        },
    },
    {
        path: '/ym/quota',
        name: 'ym-quota',
        component: () =>
            import("../../views/pc/president/ym-quota/ym-quota.vue"),
        meta: {
            title: '指标概览'
        },
    },
    {
        path: '/ym/profit',
        name: 'ym-profit',
        component: () =>
            import("../../views/pc/president/ym-profit/ym-profit.vue"),
        meta: {
            title: '单位利润计划与实际比'
        },
    },
    /////////////////// 养成 ////////////////////// 
    {
        path: '/yc',
        name: 'yc',
        component: () =>
            import("../../views/pc/president/yc.vue"),
        meta: {
            title: '养成'
        },
    }, {
        path: '/yc/annals-target',
        name: 'yc-annals-target',
        component: () =>
            import("../../views/pc/president/yc-annals-target/yc-annals-target.vue"),
        meta: {
            title: '年度经营目标完成情况'
        },
    },
    {
        path: '/yc/put',
        name: 'yc-put',
        component: () =>
            import("../../views/pc/president/yc-put/yc-put.vue"),
        meta: {
            title: '投放概览'
        },
    },
    {
        path: '/yc/overage',
        name: 'yc-overage',
        component: () =>
            import("../../views/pc/president/yc-overage/yc-overage.vue"),
        meta: {
            title: '存塘概览'
        },
    },
    {
        path: '/yc/cost',
        name: 'yc-cost',
        component: () =>
            import("../../views/pc/president/yc-cost/yc-cost.vue"),
        meta: {
            title: '成本概览'
        },
    },
    {
        path: '/yc/harvest',
        name: 'yc-harvest',
        component: () =>
            import("../../views/pc/president/yc-harvest/yc-harvest.vue"),
        meta: {
            title: '收获概览'
        },
    },
    {
        path: '/yc/sales',
        name: 'yc-sales',
        component: () =>
            import("../../views/pc/president/yc-sales/yc-sales.vue"),
        meta: {
            title: '销售概览'
        },
    },
    {
        path: '/yc/quota',
        name: 'yc-quota',
        component: () =>
            import("../../views/pc/president/yc-quota/yc-quota.vue"),
        meta: {
            title: '指标概览'
        },
    },
    {
        path: '/yc/profit',
        name: 'yc-profit',
        component: () =>
            import("../../views/pc/president/yc-profit/yc-profit.vue"),
        meta: {
            title: '单位利润计划与实际比'
        },
    },
];





//////////////////// 子公司中层管理 //////////////////////

//////////////////// 子公司中层管理 （后续开发） //////////////////////

export const subRoutes = [{
        path: '/day',
        name: 'day',
        redirect: `/day/ym`,
        meta: {
            title: '日桌面'
        },
    },
    {
        path: '/day/ym',
        name: 'day-ym',
        component: () =>
            import("../../views/pc/middle/day/ym.vue"),
        meta: {
            title: '育苗'
        },
    },
    {
        path: '/day/ym/seedling-details',
        name: 'day-ym-seedling-details',
        component: () =>
            import("../../views/pc/middle/day/ym-seedling-details/ym-seedling-details.vue"),
        meta: {
            title: '育苗成本统计明细表'
        },
    },
    {
        path: '/day/ym/feed',
        name: 'day-ym-feed',
        component: () =>
            import("../../views/pc/middle/day/ym-feed/ym-feed.vue"),
        meta: {
            title: '饲料实时有效库存'
        },
    },

    {
        path: '/day/ym/feed-feeding',
        name: 'day-ym-feed-feeding',
        component: () =>
            import("../../views/pc/middle/day/ym-feed/ym-feed-feeding.vue"),
        meta: {
            title: '饲料投喂记录'
        },
    },
    {
        path: '/day/ym/feed-in-out',
        name: 'day-ym-feed-in-out',
        component: () =>
            import("../../views/pc/middle/day/ym-feed/ym-feed-in-out.vue"),
        meta: {
            title: '饲料进出存'
        },
    },

    {
        path: '/day/ym/drug',
        name: 'day-ym-drug',
        component: () =>
            import("../../views/pc/middle/day/ym-drug/ym-drug.vue"),
        meta: {
            title: '动保实时有效库存'
        },
    },
    {
        path: '/day/ym/drug-used',
        name: 'day-ym-drug-used',
        component: () =>
            import("../../views/pc/middle/day/ym-drug/ym-drug-use.vue"),
        meta: {
            title: '动保使用记录'
        },
    },
    {
        path: '/day/ym/drug-in-out',
        name: 'day-ym-drug-in-out',
        component: () =>
            import("../../views/pc/middle/day/ym-drug/ym-drug-in-out.vue"),
        meta: {
            title: '动保进出存'
        },
    },




    {
        path: '/day/yc',
        name: 'day-yc',
        component: () =>
            import("../../views/pc/middle/day/yc.vue"),
        meta: {
            title: '养成'
        },
    },
    {
        path: '/day/yc/cost-details',
        name: 'day-yc-cost-details',
        component: () =>
            import("../../views/pc/middle/day/yc-cost-details/yc-cost-details.vue"),
        meta: {
            title: '养成成本统计明细表'
        },
    },
    {
        path: '/day/yc/feed',
        name: 'day-yc-feed',
        component: () =>
            import("../../views/pc/middle/day/yc-feed/yc-feed.vue"),
        meta: {
            title: '饲料实时有效库存'
        },
    },
    {
        path: '/day/yc/drug',
        name: 'day-yc-drug',
        component: () =>
            import("../../views/pc/middle/day/yc-drug/yc-drug.vue"),
        meta: {
            title: '动保实时有效库存'
        },
    },
    {
        path: '/month',
        name: 'month',
        redirect: `/month/ym`,
        meta: {
            title: '月桌面'
        },
    },
    {
        path: '/month/ym',
        name: 'month-ym',
        component: () =>
            import("../../views/pc/middle/month/ym.vue"),
        meta: {
            title: '育苗'
        },
    },

    {
        path: '/month/ym/annals-target',
        name: 'month-ym-annals-target',
        component: () =>
            import("../../views/pc/middle/month/ym-annals-target/ym-annals-target.vue"),
        meta: {
            title: '年度经营目标完成情况-育苗'
        },
    },
    {
        path: '/month/ym/put',
        name: 'month-ym-put',
        component: () =>
            import("../../views/pc/middle/month/ym-put/ym-put.vue"),
        meta: {
            title: '投放概览'
        },
    },
    {
        path: '/month/ym/loss',
        name: 'month-ym-loss',
        component: () =>
            import("../../views/pc/middle/month/ym-put/ym-loss.vue"),
        meta: {
            title: '明细-损失数据查询'
        },
    },


    {
        path: '/month/ym/overage',
        name: 'month-ym-overage',
        component: () =>
            import("../../views/pc/middle/month/ym-overage/ym-overage.vue"),
        meta: {
            title: '存塘概览'
        },
    },
    {
        path: '/month/ym/sampling',
        name: 'month-ym-sampling',
        component: () =>
            import("../../views/pc/middle/month/ym-overage/ym-sampling.vue"),
        meta: {
            title: '采样数据报表'
        },
    },
    {
        path: '/month/ym/farming',
        name: 'month-ym-farming',
        component: () =>
            import("../../views/pc/middle/month/ym-overage/ym-farming.vue"),
        meta: {
            title: '箱养殖动态报表'
        },
    },
    {
        path: '/month/ym/overage-condition',
        name: 'month-ym-overage-condition',
        component: () =>
            import("../../views/pc/middle/month/ym-overage/ym-overage-condition.vue"),
        meta: {
            title: '育苗存塘成本统计明细表'
        },
    },


    {
        path: '/month/ym/cost',
        name: 'month-ym-cost',
        component: () =>
            import("../../views/pc/middle/month/ym-cost/ym-cost.vue"),
        meta: {
            title: '成本概览'
        },
    },
    {
        path: '/month/ym/seedling-costs',
        name: 'month-ym-seedling-costs',
        component: () =>
            import("../../views/pc/middle/month/ym-cost/ym-seedling-costs.vue"),
        meta: {
            title: '育苗结转成本统计'
        },
    },

    {
        path: '/month/ym/harvest',
        name: 'month-ym-harvest',
        component: () =>
            import("../../views/pc/middle/month/ym-harvest/ym-harvest.vue"),
        meta: {
            title: '收获概览'
        },
    },
    {
        path: '/month/ym/sales',
        name: 'month-ym-sales',
        component: () =>
            import("../../views/pc/middle/month/ym-sales/ym-sales.vue"),
        meta: {
            title: '销售概览'
        },
    },
    {
        path: '/month/ym/quota',
        name: 'month-ym-quota',
        component: () =>
            import("../../views/pc/middle/month/ym-quota/ym-quota.vue"),
        meta: {
            title: '指标概览'
        },
    },
    {
        path: '/month/ym/profit',
        name: 'month-ym-profit',
        component: () =>
            import("../../views/pc/middle/month/ym-profit/ym-profit.vue"),
        meta: {
            title: '单位利润计划与实际比'
        },
    },
    {
        path: '/month/ym/profit/detailed',
        name: 'month-ym-profit-detailed',
        component: () =>
            import("../../views/pc/middle/month/ym-profit/ym-profit-page-detailed.vue"),
        meta: {
            title: '育苗养殖利润与指标分析'
        },
    },



    {
        path: '/month/yc',
        name: 'month-yc',
        component: () =>
            import("../../views/pc/middle/month/yc.vue"),
        meta: {
            title: '养成'
        },
    },
    {
        path: '/month/yc/annals-target',
        name: 'month-yc-annals-target',
        component: () =>
            import("../../views/pc/middle/month/yc-annals-target/yc-annals-target.vue"),
        meta: {
            title: '年度经营目标完成情况-养成'
        },
    },
    {
        path: '/month/yc/put',
        name: 'month-yc-put',
        component: () =>
            import("../../views/pc/middle/month/yc-put/yc-put.vue"),
        meta: {
            title: '投放概览'
        },
    },
    {
        path: '/month/ym/put/details',
        name: 'month-ym-put-details',
        component: () =>
            import("../../views/pc/middle/month/ym-put/ym-seedling-records.vue"),
        meta: {
            title: '投放记录'
        },
    },
    {
        path: '/month/yc/overage',
        name: 'month-yc-overage',
        component: () =>
            import("../../views/pc/middle/month/yc-overage/yc-overage.vue"),
        meta: {
            title: '存塘概览'
        },
    },
    {
        path: '/month/yc/sampling',
        name: 'month-yc-sampling',
        component: () =>
            import("../../views/pc/middle/month/yc-overage/yc-sampling.vue"),
        meta: {
            title: '采样数据报表'
        },
    },
    {
        path: '/month/yc/farming',
        name: 'month-yc-farming',
        component: () =>
            import("../../views/pc/middle/month/yc-overage/yc-farming.vue"),
        meta: {
            title: '箱养殖动态报表'
        },
    },
    {
        path: '/month/yc/overage-condition',
        name: 'month-yc-overage-condition',
        component: () =>
            import("../../views/pc/middle/month/yc-overage/yc-overage-condition.vue"),
        meta: {
            title: '养成存塘成本统计明细表'
        },
    },

    {
        path: '/month/yc/cost',
        name: 'month-yc-cost',
        component: () =>
            import("../../views/pc/middle/month/yc-cost/yc-cost.vue"),
        meta: {
            title: '成本概览'
        },
    }, {
        path: '/month/yc/seedling-costs',
        name: 'month-yc-seedling-costs',
        component: () =>
            import("../../views/pc/middle/month/yc-cost/yc-seedling-costs.vue"),
        meta: {
            title: '养成结转成本统计'
        },
    },

    {
        path: '/month/yc/harvest',
        name: 'month-yc-harvest',
        component: () =>
            import("../../views/pc/middle/month/yc-harvest/yc-harvest.vue"),
        meta: {
            title: '收获概览'
        },
    },
    {
        path: '/month/yc/sales',
        name: 'month-yc-sales',
        component: () =>
            import("../../views/pc/middle/month/yc-sales/yc-sales.vue"),
        meta: {
            title: '销售概览'
        },
    },
    {
        path: '/month/yc/quota',
        name: 'month-yc-quota',
        component: () =>
            import("../../views/pc/middle/month/yc-quota/yc-quota.vue"),
        meta: {
            title: '指标概览'
        },
    },
    {
        path: '/month/yc/profit',
        name: 'month-yc-profit',
        component: () =>
            import("../../views/pc/middle/month/yc-profit/yc-profit.vue"),
        meta: {
            title: '单位利润计划与实际比'
        },
    },
    {
        path: '/month/yc/profit/detail',
        name: 'month-yc-profit-detail',
        component: () =>
            import("../../views/pc/middle/month/yc-profit/yc-profit-page-detailed.vue"),
        meta: {
            title: '养成养殖利润与指标分析'
        },
    },

];